import React, { useEffect } from "react";

import { WEB_ROUTES } from "../../constants";
import styles from "./styles/Courses.module.scss";

import _ from "lodash";
import { Col, Row, Spinner } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import CourseBanner from "../../Components/Cards/CourseBanner";
import EmptyContainer from "../../Components/Container/EmptyContainer";
import { Button, SubTitle } from "../../Components/CustomComponents";
import { useGetBatchByTrainingIdQuery } from "../../Data/services/batchesApi";
import BatchComponent from "./BatchComponent";
import { useEnrollTrainingMutation } from "../../Data/services/trainingApi";
import { ErrorToast, SuccessToast } from "../../Hooks/useToast";
import { useSelector } from "react-redux";

export default function Batches({ setPage }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { item } = location.state || {};
  const { isLoading, error } = useGetBatchByTrainingIdQuery(item?.id);
  const data = useSelector(state => state.batch);

  const [enrollTraining, { isError, isLoading: isTrainingEnrolling }] = useEnrollTrainingMutation()


  useEffect(() => {
    if (_.isEmpty(item)) {
      navigate(`/${WEB_ROUTES.DASHBOARD}`)
    }
  }, [])


  const handleBackButtonClck = () => {
    navigate(-1);
  };

  const handleBatchDetails = (item) => {
    navigate(`/${WEB_ROUTES.CLASSES}`, {
      state: {
        item: {
          id: item.id,
          name: item.name,
          image_url: item.image_url,
          description: item.description
        }
      }
    });
  };




  const handleEnrollTraining = async () => {
    try {
      const response = await enrollTraining({ training_id: item.id }).unwrap();
      SuccessToast("Tranining Enrolled Successfully");
      navigate(`/${WEB_ROUTES.BATCHES}`, {
        replace: true,
        state: {
          item: {
            ...item,
            is_enrolled: 1
          }
        }
      })

    } catch (err) {
      ErrorToast(err.data?.message);
    }
  }


  return (
    <div className={styles.Courses}>
      {_.isEmpty(item) ? "" :
        <CourseBanner
          hasBackButton={true}
          handleBackButtonClck={handleBackButtonClck}
          title={item?.title}
          image_url={item?.image_url}
        />
      }

      <div className={styles.headerContainer}>
        <SubTitle text={""} />
      </div>
      {!!item.is_enrolled ? "" :
        <Button
          classes={`rounded-4 px-4 py-3 my-2 fw-bold gradientBg shadowBlur`}
          onClick={handleEnrollTraining}
          text={
            (isTrainingEnrolling) ? <Spinner /> :
              "Enroll Training"
          }
        />
      }

      <Row>
        {isLoading ?
          <EmptyContainer text={<Spinner size="lg" />} classes="my-2" /> :
          (_.isEmpty(data?.data) || error) ? <EmptyContainer classes="my-2" /> :
            (data?.data || [])?.map((batch, index) => {
              return (
                <Col xs="12" sm="6" md="4" lg="4" xl="3" xxl="2" className="my-2" key={batch.id}>
                  <BatchComponent
                    id={batch.id}
                    title={batch.name}
                    image_url={batch.image_url}
                    description={batch.description}
                    onSelect={() => handleBatchDetails(batch)}
                    is_enrolled={batch.is_enrolled}
                    hasDetailAccess={!!item.is_enrolled}
                  />
                </Col>
              );
            })}
      </Row>
    </div>
  );
}
